<app-update-data
  *ngIf="requireUpdate"
  (requireUpdate)="requireUpdate = $event"
  [numberId]="this.bnplService.stepsInformation.firstStep.numeroDocumento"
/>
<app-automatic-debit
  *ngIf="automaticDebit"
  (setAutoDebitAccount)="autoDebitAccountSelected = $event"
  (changeAutomaticDebit)="automaticDebit = $event"
  [visbleCancel]="false"
/>

<div *ngIf="commerce != 'true'" class="contenedor">
  <h3>¿Cuánta plata necesitas para tu compra?</h3>

  <section class="container--convenio">
    <section
      class="container--convenio--style container--convenio--style--cupo"
    >
      <p>Cupo disponible</p>
      <b>{{ amountFinance | currency : "USD" : "symbol" : "1.0-0" }}</b>
    </section>

    <div
      *ngIf="isLargeScreen"
      class="container--convenio--separador"
      #separador
    ></div>

    <section
      class="container--convenio--style container--convenio--style--convenio"
    >
      <p>Convenio</p>
      <div class="storeSelectedContainer" id="storeSelectedContainer">
        <select
          name="storeSelected"
          id="storeSelectedInput"
          [(ngModel)]="storeSelected"
          class="storeSelectedInput"
          (click)="handleCarouselMaskTutoTimer(false); handleResetBranch()"
        >
          <option [ngValue]="null" disabled selected>
            Selecciona un aliado
          </option>
          <option
            *ngFor="let entry of storesListEntries"
            [ngValue]="entry[1]"
            (click)="handleResetBranch()"
          >
            {{ entry[0] }}
          </option>
        </select>
      </div>
    </section>

    <div
      *ngIf="!isLargeScreen"
      class="container--convenio--separador"
      #separador
    ></div>
  </section>

  <div
    class="branchStoreSelectedContainer"
    id="branchStoreSelectedContainer"
    *ngIf="storeSelected !== null"
  >
    <h1
      *ngIf="storeSelected.length <= 3"
      class="storeSelectedLabel"
      id="branchStoreSelectedLabel"
    >
      Elige una sucursal
    </h1>
    <h1
      *ngIf="storeSelected.length > 3"
      class="storeSelectedLabel"
      id="branchStoreSelectedLabel"
    >
      Busca una sucursal
    </h1>
    <div
      class="finderBranchsContainer"
      id="finderBranchsContainer"
      *ngIf="storeSelected.length > 3"
    >
      <input
        type="text"
        [(ngModel)]="branchFinder"
        placeholder="Busca la sucursal"
        class="finderBranchsInput"
        id="finderBranchsInput"
        (ngModelChange)="filteredBranchs()"
        [value]="branchFinder"
        autocomplete="off"
      />
      <ul
        class="finderBranchsList"
        id="finderBranchsList"
        *ngIf="findListBranchs && !selectedBranchStore"
      >
        <li
          class="finderBranchsItem"
          id="finderBranchsItem"
          *ngFor="let storeBranch of findListBranchs"
          [value]="storeBranch"
          [(ngModel)]="selectedBranchStore"
          (click)="filterPartner(storeBranch)"
        >
          <img [src]="urlImage + '/' + storeBranch.brand + '.png'" alt="" />
          <h2>{{ storeBranch.partnerName }}</h2>
        </li>
      </ul>
    </div>
    <swiper-container
      slides-per-view="auto"
      space-between="16"
      class="carouselContainer"
      slide-to-clicked-slide="true"
      [enabled]="!carouselTuto"
      *ngIf="storeSelected.length <= 3"
    >
      <div
        class="carouselMask"
        id="carouselMask"
        [ngClass]="
          carouselTuto ? 'carouselMaskVisible' : 'carouselMaskInvisible'
        "
        (click)="handleCarouselMaskTuto(false)"
      >
        ← Desliza para seleccionar tu sucursal →
      </div>
      <swiper-slide
        *ngFor="let storeBranch of storeSelected"
        class="slideContent"
      >
        <label class="pill">
          <input
            type="radio"
            name="branchSelection"
            [value]="storeBranch"
            (click)="filterPartner(storeBranch)"
          />
          <div class="pillContent">
            <img [src]="urlImage + '/' + storeBranch.brand + '.png'" alt="" />
            <div class="pillTextContent">
              <h2>Sucursal</h2>
              <h1>{{ storeBranch.partnerName }}</h1>
            </div>
          </div>
        </label>
      </swiper-slide>
    </swiper-container>
  </div>

  <div class="formulario">
    <app-form
      [controls]="selectionBuy$ | async"
      [desabledButton]="desabledButton"
      (sendInfo)="getSelectionBuys($event)"
      (selectedClient)="getCuotasSelected($event)"
    ></app-form>
  </div>
</div>

<div *ngIf="commerce === 'true'" class="contenedor-commerce">
  <h3>Elige las cuotas</h3>
  <div style="width: 60%">
    <div class="contenedor-credito">
      <p style="font-size: 16px">Valor de la compra</p>
      <p class="ammount">${{ ammount }}</p>
    </div>
    <div class="contenedor-ref-pago">
      <p style="font-size: 16px">Referencia de pago</p>
      <p class="ammount">{{ referenPay }}</p>
    </div>
  </div>

  <div class="formulario">
    <app-form
      [controls]="selectionBuy$ | async"
      (sendInfo)="getSelectionBuys($event)"
      (selectedClient)="getCuotasSelected($event)"
    ></app-form>
  </div>
</div>

<!-- <div class="check-style druo druo-active" *ngIf="dataDruo != null">
    <label class="form-check-label" for="flexCheckDefault"><b> Débito automático activado </b></label>
    <span><img [src]="dataDruo.imgBank"alt="Logo Banco" 
      width="24px" 
      height="auto" 
      style="margin-right: 0.5rem;" > {{ dataDruo.nameBank }}</span>
    <label *ngIf="dataDruo.numShort">Cuenta: {{ dataDruo.numShort }}</label>
    <label *ngIf="!dataDruo.numShort">{{ dataDruo.numero.length > 4 ? '***' + dataDruo.numero.slice(-4) : dataDruo.numero }}</label>
    <p class="update-bank" (click)="openDialogDruo()">Modificar</p>
  </div> -->

<!-- <div class="check-style druo druo-active" *ngIf="dataDruo != null">
    <label class="form-check-label" for="flexCheckDefault"><b> Débito automático activado </b></label>
    <span><img [src]="dataDruo.imgBank"alt="Logo Banco" 
      width="24" 
      height="auto" 
      style="margin-right: 0.5rem;" > {{ dataDruo.nameBank }}</span>
    <label *ngIf="dataDruo.numShort">Cuenta: {{ dataDruo.numShort }}</label>
    <label *ngIf="!dataDruo.numShort">{{ dataDruo.numero.length > 4 ? '***' + dataDruo.numero.slice(-4) : dataDruo.numero }}</label>
    <p class="update-bank" (click)="openDialogDruo()">Modificar</p>
  </div> -->
